import urls from 'src/urls/workspaces';
import { createHttpRequest } from 'src/utils/http-request';

export type CompassApi = {
  getCloudIdsForWorkspace: (
    workspaceSlug: string
  ) => Promise<GetCompassCloudIdsData>;
  getCloudIdsForRepository: (
    workspaceSlug: string,
    repositorySlug: string
  ) => Promise<GetCompassCloudIdsData>;
};

export type GetCompassCloudIdsData = {
  connectedCloudIds: string[];
};

export const compassApi = (): CompassApi => ({
  getCloudIdsForWorkspace: (workspaceSlug: string) =>
    createHttpRequest<GetCompassCloudIdsData>('GET')(
      urls.api.internal.getCompassCloudIdsForWorkspace(workspaceSlug)
    ),
  getCloudIdsForRepository: (workspaceSlug: string, repositorySlug: string) =>
    createHttpRequest<GetCompassCloudIdsData>('GET')(
      urls.api.internal.getCompassCloudIdsForRepository(
        workspaceSlug,
        repositorySlug
      )
    ),
});
